<template>
    <div id="ControSystem">
        <view1/>
        <view2/>
        <view3/>
        <view4/>
    </div>
</template>
<script> 
export default {
  name: 'ControlSystem',
  components: {
    // 所有子组件异步加载，实现代码分割
    view1: () => import('@/views/ControlSystem/view1.vue'),
    view2: () => import('@/views/ControlSystem/view2.vue'),
    view3: () => import('@/views/ControlSystem/view3.vue'),
    view4: () => import('@/views/ControlSystem/view4.vue')
  }
}
</script>